import { BannerTileStoryblok } from 'storyblok-types';
import { isValidDate } from 'modules/stroyblok/services';
import { IAdaptedListProduct } from 'commerce/scayle/utils/adapter/types';
import { GridBanner } from 'commerce/services/types';

export const mergeBannerWithProduct = (
  products: IAdaptedListProduct[] = [],
  stories: GridBanner[] = [],
) => {
  const bannerAndProducts = [];

  const bannerMap = stories?.reduce<Record<number, BannerTileStoryblok>>(
    (memo, config) => {
      if (!config) {
        return memo;
      }

      return {
        ...memo,
        // 60 - tiles per section
        [(config.gridIdx - 1) % 60]: config.banner.content,
      };
    },
    {},
  );

  for (let i = 0; i < products.length; i++) {
    if (i in bannerMap) {
      const banner = bannerMap[i];

      const isValid =
        !banner.start_date ||
        !banner.expiration_date ||
        isValidDate(banner.start_date, banner.expiration_date);

      if (isValid) {
        bannerAndProducts.push(bannerMap[i]);
      }
    }

    bannerAndProducts.push(products[i]);
  }

  return bannerAndProducts;
};
